// Adapted from Hosanna 1412aa0; see docs/search.md.
const BM25_K1 = 1.2;
const BM25_B = 0.75;
export function buildBm25DocumentProfile(normalizedText) {
    const termFrequencies = new Map();
    const tokens = normalizedText.split(' ').filter(Boolean);
    for (const token of tokens) {
        termFrequencies.set(token, (termFrequencies.get(token) ?? 0) + 1);
    }
    return { termFrequencies, length: tokens.length };
}
function createBm25CollectionStats(profiles) {
    const documentFrequency = new Map();
    let totalLength = 0;
    for (const profile of profiles) {
        totalLength += profile.length;
        for (const term of profile.termFrequencies.keys()) {
            documentFrequency.set(term, (documentFrequency.get(term) ?? 0) + 1);
        }
    }
    return { count: profiles.length, totalLength, documentFrequency };
}
export function buildBm25CorpusStats(documentProfiles, fragmentProfiles) {
    return {
        documents: createBm25CollectionStats(documentProfiles),
        fragments: createBm25CollectionStats(fragmentProfiles),
    };
}
export function scoreBm25(profile, queryTerms, collection) {
    if (collection.count === 0 || profile.length === 0)
        return 0;
    const averageLength = collection.totalLength / collection.count;
    if (averageLength <= 0)
        return 0;
    let score = 0;
    for (const term of new Set(queryTerms.filter(Boolean))) {
        const termFrequency = profile.termFrequencies.get(term) ?? 0;
        const documentFrequency = collection.documentFrequency.get(term) ?? 0;
        if (termFrequency === 0 || documentFrequency === 0)
            continue;
        const inverseDocumentFrequency = Math.log(1 + (collection.count - documentFrequency + 0.5) / (documentFrequency + 0.5));
        const lengthNormalization = BM25_K1 * (1 - BM25_B + BM25_B * profile.length / averageLength);
        score += inverseDocumentFrequency
            * (termFrequency * (BM25_K1 + 1))
            / (termFrequency + lengthNormalization);
    }
    return score;
}
